import {Stack, Typography, Button} from '@mui/material';

export function SortingButtons({ currentlySortedBy,  sortRows, topPadding, theme }) {
    let buttonStyling = {
        border: theme.palette.sortButton.border,
        backgroundColor: theme.palette.sortButton.background,
        textColor: theme.palette.sortButton.text,
        selectedTextColor: theme.palette.sortButton.selectedText,
        selectedBackgroundColor: theme.palette.sortButton.selected,
        hoverColor: theme.palette.sortButton.hover,
        headerBackground: theme.palette.background.default,
        bottomBorder: theme.palette.sortButton.bottomBorder,
    }

    let buttonFormat = {
        borderRadius: '20px', 
        textTransform: 'none',
        border: "none",
        '&:hover': {
            backgroundColor: buttonStyling.hoverColor,
        },
    }
    
    return (
    <Stack direction="row" spacing={2} sx={{ borderBottom: buttonStyling.bottomBorder, paddingBottom: topPadding, width: '100%', paddingTop: topPadding, backgroundColor: buttonStyling.headerBackground, alignItems: 'center' }}>
            <Typography variant='h6' sx={{borderRight: buttonStyling.border, paddingRight: '1em', paddingLeft: '1em'}}>
                Sort
            </Typography>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: currentlySortedBy === 'call_sign' ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor, 
                color: currentlySortedBy === 'call_sign' ? buttonStyling.selectedTextColor : buttonStyling.textColor, 
            }} onClick={() => sortRows('call_sign')}>Call Sign</Button>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: currentlySortedBy === 'affiliation' ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor, 
                color: currentlySortedBy === 'affiliation' ? buttonStyling.selectedTextColor : buttonStyling.textColor, 
                }} onClick={() => sortRows('affiliation')}>Affiliate</Button>
            <Button variant="outlined" sx={{
                ...buttonFormat,
                backgroundColor: currentlySortedBy === 'market' ? buttonStyling.selectedBackgroundColor : buttonStyling.backgroundColor, 
                color: currentlySortedBy === 'market' ? buttonStyling.selectedTextColor : buttonStyling.textColor, 
                }} onClick={() => sortRows('market')}>Market</Button>
        </Stack>
    );
}